import * as swcHelpers from '@swc/helpers';
import { getLocalizedString } from '@grandvisionhq/utils';
import { EyeSide } from '../../../../__generated__/sharedTypes.js';
import { toBaseLineItem } from './base-line-item.js';

const toEyeSide = (eyeSide)=>{
    switch(eyeSide){
        case EyeSide.LEFT:
            return 'left';
        case EyeSide.RIGHT:
            return 'right';
        case EyeSide.BOTH:
            return 'both';
    }
};
const toEyeSideLabelKey = (eyeSide)=>{
    switch(eyeSide){
        case EyeSide.LEFT:
            return 'products.contactLenses.leftEye';
        case EyeSide.RIGHT:
            return 'products.contactLenses.rightEye';
        case EyeSide.BOTH:
            return 'products.contactLenses.both';
    }
};
const toEyePrescription = (prescription)=>{
    if (!prescription) {
        return undefined;
    }
    return {
        addition: (prescription === null || prescription === void 0 ? void 0 : prescription.addition) || null,
        axis: (prescription === null || prescription === void 0 ? void 0 : prescription.axis) || null,
        baseCurve: (prescription === null || prescription === void 0 ? void 0 : prescription.baseCurve) || null,
        cylinder: (prescription === null || prescription === void 0 ? void 0 : prescription.cylinder) || null,
        diameter: (prescription === null || prescription === void 0 ? void 0 : prescription.diameter) || null,
        dominance: (prescription === null || prescription === void 0 ? void 0 : prescription.dominance) || null,
        power: (prescription === null || prescription === void 0 ? void 0 : prescription.power) || null
    };
};
const toContactLensesOrderLineItem = (orderLineItem, intl, options = {})=>{
    const { eyeSide , prescription  } = orderLineItem;
    const { boxQuantity , replacementFrequency  } = orderLineItem.product;
    const eyeSideLabelKey = toEyeSideLabelKey(eyeSide);
    return swcHelpers.objectSpread({}, toBaseLineItem(orderLineItem, intl, options), {
        type: 'CONTACT_LENSES',
        subtitle: `${boxQuantity} ${getLocalizedString(replacementFrequency, intl.locale)} ${intl.getLabel('products.unit.contactLenses')} ${intl.getLabel('products.perBox')}, ${intl.getLabel(eyeSideLabelKey)}`,
        eyeSide: toEyeSide(eyeSide),
        prescription: toEyePrescription(prescription)
    });
};

export { toContactLensesOrderLineItem };
//# sourceMappingURL=contact-lenses-line-item.js.map
